export interface Page {
  display_label?: any;
  normalized_rank?: number;
  id: number;
  name: string;
  type: PageType;
  block_id: number;
  rank: number;
  randomize_elements: boolean;
}

export enum PageType {
  ELEMENT_PAGE_MODEL = 'ElementPageModel',
  LOGIC_PAGE_MODEL = 'LogicPageModel',
  ENDING_PAGE_MODEL = 'EndingPageModel',
}
